import React from "react";
import Content from "../../_utilities/data/sections/industries.json";
import Image from "next/image";

interface IndustriesItem {
  icon: string;
  subtitle: string;
}

const IndustriesSection: React.FC = () => {
  const items: IndustriesItem[] = Content.items;

  return (
    <section className="mil-icon-boxes" style={{marginBottom:"35px"}}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="row  ">
              {items.map((item, index) => (
                <div className="col-md-2 col-sm-4  col-6 mil-process" key={index}>
                  <div className="mil-icon-box mil-center ">
                    <div className="mil-icon-frame-md  industries-icon">
                      <div className="mil-mb-30">
                        <Image
                          src={item.icon}
                      alt={item.subtitle}
                          //set the size of the icon of industry we serve
                          height={80}
                          width={80}
                        />
                    </div>
                    <p
                      className="mil-mb-20 mil-h5"
                      style={{fontSize: "16px"}}
                      //change the size of font
                      // style={{ fontSize: "medium" }}
                    >
                      {item.subtitle}
                    </p>
                   
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="row justify-content-between">
              {secondRow.map((item, index) => (
                <div className="col-md-2" key={index}>
                  <div className="mil-icon-box mil-center mil-mb-30">
                    <div className="mil-icon-frame-md mil-mb-30">
                      <div href="/" className="industries-icon">
                        <Image
                          src={item.icon}
                          alt="icon"
                          height={110}
                          width={110}
                        />
                      </div>
                    </div>
                    <p
                      className="mil-text-sm mil-mb-20"
                      style={{ fontSize: "large" }}
                    >
                      {item.subtitle}
                    </p>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
